import { tss } from 'tss-react/mui';

const useStyles = tss
  .withParams<{
    enableTimeFilter: boolean;
  }>()
  .create(({ theme, enableTimeFilter }) => ({
    dialogContainer: {
      backgroundColor: theme.vars.palette.transparent.a25,
      'MuiDialog-container': {
        backgroundColor: theme.vars.palette.background.elevation1
      }
    },
    collapseTableParent: {},
    collapseTableParentSelected: {
      backgroundColor: theme.vars.palette.transparent.a5,
      td: {
        borderBottom: `0rem solid`
      },
      '& MuiTableCell-root': {
        borderTop: `0rem solid`
      }
    },
    collapseTableInnerWrapper: {
      td: {
        borderBottom: `0rem solid`
      }
    },
    requestsTable: {
      height: '100%',
      borderCollapse: 'collapse',
      '& th': {
        padding: '0.5rem 1rem',
        backgroundColor: theme.vars.palette.background.elevation2
      }
    },
    deviceMainTable: {
      height: '100%',
      '& th': {
        padding: '0.5rem 1rem',
        backgroundColor: theme.vars.palette.background.elevation2
      }
    },
    collapseTableInner: {
      backgroundColor: theme.vars.palette.background.elevation1,
      borderBottom: '1px solid var(--mui-palette-TableCell-border)',
      '& tr th': {
        borderBottom: '0rem'
      },
      '& tr:before': {
        height: '4.75rem',
        content: '""',
        position: 'relative',
        left: '3.75rem',
        top: '0rem',
        width: '0.13rem',
        bottom: '0rem',
        display: 'flex',
        borderLeft: '0.125rem dashed',
        opacity: '.3'
      },
      '& tr:last-child:before': {
        height: '2.4rem'
      }
    },
    dFlex: {
      display: 'flex'
    },
    alignSelfCenter: {
      alignSelf: 'center'
    },
    devicesTablePagination: {
      backgroundColor: theme.vars.palette.background.elevation2,
      borderTop: `1px solid ${theme.vars.palette.border.light}`,
      bottom: 0,
      display: 'relative',
      position: 'sticky',
      zIndex: 29
    },
    deviceStatusIconStyle: {
      height: '2.75rem'
    },
    iconCollapse: {
      cursor: 'pointer',
      width: '1.375rem',
      fontSize: '1.125rem',
      alignSelf: 'center'
    },
    collapseTableInnerRow: {},
    collapseTableInnerRowSelected: {
      backgroundColor: theme.vars.palette.transparent.a10,
      border: `1px solid ${theme.vars.palette.primary.main}`
    },
    cellHeaderw: {
      width: '100%'
    },

    statusInfoAccordion: {
      backgroundColor: theme.vars.palette.background.elevation1
    },
    statusInfoAccordionDetails: {
      backgroundColor: theme.vars.palette.background.elevation2
    },
    icoLabelStyle: {
      alignSelf: 'center',
      minWidth: '1.5rem',
      paddingLeft: '1rem'
    },
    deviceTableContainer: {
      height: '100%',
      minHeight: 500,
      position: 'relative',
      boxShadow: theme.shadows[2],
      borderRadius: 4,
      backgroundColor: theme.vars.palette.background.elevation2,
      gridRow: 'span 4',
      [theme.breakpoints.down('md')]: {
        gridColumn: 'span 2',
        gridRow: 'span 1'
      },
      '& td': {
        paddingBottom: '.8rem',
        paddingTop: '.8rem'
      }
    },
    deviceDetailsCard: {
      height: '100%',
      minHeight: 500,
      position: 'relative',
      boxShadow: theme.shadows[2],
      borderRadius: 4,
      backgroundColor: theme.vars.palette.background.elevation1,
      gridRow: 'span 4',
      [theme.breakpoints.down('md')]: {
        gridColumn: 'span 2',
        gridRow: 'span 1'
      }
    },
    ellipsisMenu: {
      '& ul': {
        backgroundColor: theme.vars.palette.background.elevation1
      },
      '& li:hover': {
        backgroundColor: theme.vars.palette.background.elevation0
      }
    },
    textInputWrapper: {
      flex: 1,
      minWidth: '2rem',
      position: 'relative',
      height: '1.25rem',
      display: 'flex',
      alignItems: 'center'
    },
    searchbar: {
      display: 'flex',
      flexWrap: 'wrap',
      gap: theme.spacing(1)
    },
    searchbarInput: {
      display: 'flex',
      flex: 1,
      alignItems: 'center',
      borderRadius: !enableTimeFilter
        ? `${theme.shape.borderRadius}px 0 0 ${theme.shape.borderRadius}px`
        : 0,
      borderWidth: '1px 0 1px 1px',
      borderStyle: 'solid',
      borderColor: theme.vars.palette.border.main,
      padding: theme.spacing(0, 0.5),
      gap: theme.spacing(0.5),
      overflow: 'hidden',
      '& input': {
        border: 0,
        outline: 'none',
        flex: 1,
        background: theme.vars.palette.transparent.a0,
        width: '100%',
        color: theme.vars.palette.text.primary,
        position: 'absolute',
        left: 0,
        right: 0,
        fontSize: '0.875rem'
      }
    },
    searchbarInputContainer: {
      [theme.breakpoints.down('lg')]: {
        width: '100%'
      },
      [theme.breakpoints.down('xxl')]: {
        searchbarInputContainerminWidth: '10vw'
      },
      display: 'flex',
      minWidth: '23vw'
    },
    searchbarSearchBtn: {
      borderRadius: `0 ${theme.shape.borderRadius}px ${theme.shape.borderRadius}px 0`,
      backgroundColor: theme.vars.palette.transparent.a10,
      padding: theme.spacing(0.5, 1)
    },
    searchbarFilterChip: {
      maxWidth: '15rem',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap'
    },
    searchableSelectButton: {
      justifyContent: 'flex-start',
      alignItems: 'center',
      gap: '0.25rem',
      fontWeight: 400,
      padding: theme.spacing(0.5, 1.5, 0.5, 1),
      minHeight: '2rem',
      span: {
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        maxWidth: '12rem'
      },
      '.MuiButton-endIcon': {
        marginLeft: theme.spacing(0.25)
      }
    },
    warningColor: {
      color: theme.vars.palette.warning.main
    },
    routeButtonTooltip: {
      backgroundColor: theme.vars.palette.background.navigation,
      fontSize: '0.875rem'
    },
    routeButtonTooltipArrow: {
      color: theme.vars.palette.background.navigation
    },
    requestsTableWrapper: {
      backgroundColor: theme.vars.palette.background.elevation2,
      boxShadow: theme.shadows[2],
      borderRadius: 4,
      height: '100%',
      overflow: 'auto',
      position: 'relative',
      width: '100%',
      '& .ag-row': {
        fontSize: '0.875rem',
        cursor: 'pointer'
      },
      '& .ag-header': {
        fontSize: '0.875rem'
      }
    },
    tableHeaderSticky: {
      position: 'sticky',
      top: '0',
      backgroundColor: theme.vars.palette.background.elevation2,
      borderBottom: `1px solid ${theme.vars.palette.background.elevation0}`,
      zIndex: '99'
    },
    searchBar: {
      backgroundColor: theme.vars.palette.background.elevation1,
      padding: '0.5rem 1rem'
    },
    subDataRow: {
      paddingLeft: '2.5rem',
      '&:before': {
        height: '0.125rem',
        content: '""',
        position: 'relative',
        left: '0.125rem',
        top: '1.25rem',
        width: '1.25rem',
        bottom: '0rem',
        borderBottom: '0.125rem dashed',
        opacity: '.3'
      }
    },
    cldcell1: {
      width: '25%'
    },
    cldcell2: {
      width: '20%'
    },
    cldcell3: {
      width: '10%'
    },
    cldcell4: {
      width: '5%'
    }
  }));

export default useStyles;
